import React from "react";

const ADO_Command = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Command</h1>
      <p>This is the ADO Command page content.</p>
    </div>
  );
};

export default ADO_Command;
